// this is an autogenerated file from DesignSystem/SeatAction/ConfirmationDialog/Content/Content/Provider/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_SeatAction_ConfirmationDialog_Content_Content_Provider($location_id: uuid!) {
  vaxiom_employee_resources(
    where: {
      invalid: { _eq: false }
      resource: {
        organization: { _id: { _eq: $location_id } }
        resource_type: { is_provider: { _eq: true } }
      }
      employment_contract: { employment_end_date: { _is_null: true } }
    }
    order_by: {
      employment_contract: { person: { first_name: asc, last_name: asc } }
    }
  ) {
    id
    employment_contract {
      id
      person {
        id
        first_name
        last_name
      }
    }
  }
}

`